import React from 'react';
import {Flex, FlexProps} from '@chakra-ui/react';
import {Credits} from '../Icons/Credits';

export const CreditCostTag = ({
  creditCost,
  ...props
}: {
  creditCost: string | number | undefined;
} & FlexProps) => {
  return (
    <Flex
      alignItems="center"
      bgColor="kred.50"
      borderRadius="full"
      color="kred.400"
      gap="2"
      px="10px"
      py="4px"
      w="fit-content"
      {...props}
    >
      <Credits />
      {creditCost?.toLocaleString() ?? '-'}
    </Flex>
  );
};
